var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
        _vm.$style.arrow,
        _vm.open ? _vm.$style.arrowOpen : '',
        _vm.size === 'large' ? _vm.$style.arrowSizeLarge : '',
        _vm.size === 'medium' ? _vm.$style.arrowSizeMedium : '' ]})}
var staticRenderFns = []

export { render, staticRenderFns }